import RequestManager from "./../requests/RequestManager";
import LevelTask from "./../requests/tasks/cms/LevelTask";
import LevelRibbonTask from './../requests/tasks/cms/LevelRibbonTask';
import LevelUserTask from "./../requests/tasks/cms/LevelUserTask";
import UserSeenTask from "./../requests/tasks/cms/UserSeenTask";
import MusicTask from "./../requests/tasks/music/MusicTask";
import FollowRadioTask from "./../requests/tasks/music/FollowRadioTask";
import PlaylistTask from '../requests/tasks/music/PlaylistTask';
import FilterTask from '../requests/tasks/music/FilterTask';
import RibbonsTask from '../requests/tasks/music/RibbonsTask';
import RadiosTask from '../requests/tasks/music/RadiosTask';
import settings from "./../devices/all/settings";
import FilterList from "./../utils/FilterList";
import ribbonsCache from "./RibbonsCache";
import Utils from "./../utils/Utils";
import Metadata from './../requests/apa/Metadata';
import storage from '../components/DeviceStorage/DeviceStorage';
import ENTITIES_TYPES from '../containers/Music/EntityType';
import AlbumDetailAdapter from './../components/AlbumDetail/AlbumDetailAdapter';
import SetupPlayTask from '../requests/tasks/music/SetupPlayTask';
import CheckSinglePlayTask from '../requests/tasks/music/CheckSinglePlayTask';
import MyMusicDetailTask from '../requests/tasks/music/MyMusicDetailTask';
import IsFavoriteTask from '../requests/tasks/music/IsFavoriteTask';
import LoadingIptvOttFlow from '../AAF/LoaderExp/LoadingIptvOttFlow';
import { LiveObserver } from '../components/PersistentMiniEpg/MiniObserver';
import store from "../store";
import {setFromData} from "../actions/navbar"
import {
  DATA_LOAD_FAILURE,
  sendLoadAppErrorToNewRelic
} from "./newRelic_loadApp/newRelic-load-app";
import {getLastTouch} from "../requests/utils/utils-last-touch";
import {sendGAEvent} from "../utils/analytics"
import LivechannelTask from './../requests/tasks/cms/LivechannelTask';
import BygenreTask from './../requests/tasks/cms/BygenreTask';

import itemTransformerLevelV3 from '../requests/tasks/transformers/itemTransformerLevelV3';
import itemTransformerBygenre from '../requests/tasks/transformers/itemTransformerBygenre';

import logger from 'src/utils/logger/logger';

class RibbonsUtil {
  constructor() {
    this.getRibbons = this.getRibbons.bind(this);
  }

  async getMiddlewareRibbons(node, user_status, callback) {

    logger.debug('[RCACHE] getMiddlewareRibbons node 1: ', node, user_status)
    const regionStorage = storage.getItem('region');
    const showEpgRibbon = JSON.parse(
      Metadata.get(
        "showEpgRibbon",
        "{\"mexico\":[\"homeuser\"],\"argentina\":[\"homeuser\"], \"default\":[]}"
      )
    );
    const validateEpgInRegion =
      (showEpgRibbon[regionStorage] || showEpgRibbon['default'])
        .includes (node);
    const params = {
      node,
      user_status,
      first_page: true,
      show_epg_ribbon: validateEpgInRegion,
    };


    let doRequest = true;
    let idnode = node + '_' + user_status;
    idnode = idnode.replace(/,/g, '_');
    idnode = idnode.replace(/ /g, '');

    logger.debug('[RCACHE] getMiddlewareRibbons node 2: ', idnode)
    if(settings.use_ribbons_cache) {
      let nodeRibbons = ribbonsCache.get(idnode);
      if(nodeRibbons) {
        doRequest = false;
        if(typeof callback === 'function') {
          const rcallback  = callback(nodeRibbons);
          logger.debug('[RCACHE] Respuesta desde caché ', ribbonsCache)
        }
      }
    }

    if(doRequest) {
      try {
        const configActivationHBO = Utils.getRegionaliazedMetadata('wbd_hbo_max_activation_linkage_enabled');
        const isActivationHBOEnabled = configActivationHBO && configActivationHBO.enabled;
        const version = isActivationHBOEnabled ? 'v8' : 'v2'
        const task = new LevelRibbonTask('level', params, version);
        RequestManager.addRequest(task).then((response) => {

          response.response = this.resolveRibbonsIfCache(response.response);
          response.response = this.resolveRibbonsItemsIfCache(response.response);

          if(settings.use_ribbons_cache) {
            ribbonsCache.set(idnode, response.response, settings.duration_of_ribbons_in_cache);
            logger.debug('[RCACHE] se puso en cache ', ribbonsCache, response.response)
          }

        if (typeof callback === 'function') {
            const rcallback = callback(response.response);
            console.log('[RCACHE] Respuesta request Manager :', rcallback);
            logger.debug('[RCACHE] Respuesta request Manager :', rcallback)
          }
        }).catch((err) => {
          sendLoadAppErrorToNewRelic(DATA_LOAD_FAILURE)
          if (!LoadingIptvOttFlow.isLoadLive()) {
            LiveObserver.fire();
          }
        });
      } catch (e) {
        sendLoadAppErrorToNewRelic(DATA_LOAD_FAILURE)
        logger.error('[RibbondUtil] getMiddlewareRibbons err', e);
      }
    }
  }

      async getRibbonsCarrusels(paramsR, node, user_status) {
        try {
            const task = new LevelRibbonTask('level', paramsR);
            let response = await RequestManager.addRequest(task);

            response.response = this.resolveRibbonsIfCache(response.response);
            response.response = this.resolveRibbonsItemsIfCache(response.response);

            const positionCarrusel = await this.searchAPIinLevelUser('epg/v2/bygenre', response);
            response = await this.getBygenre(positionCarrusel, response)
            return response;
        } catch (err) {
            if (!LoadingIptvOttFlow.isLoadLive()) {
                LiveObserver.fire();
            }
        }
    }

  resolveRibbonsIfCache(ribbons) {
    let maxRibbons = settings.use_max_ribbons;
    if(isNaN(maxRibbons)) {
      maxRibbons = 0;
    }
    if(maxRibbons > 0) {
      if(ribbons.components && Utils.isArray(ribbons.components) && ribbons.components.length > maxRibbons) {
        ribbons.components = ribbons.components.slice(0, maxRibbons);
      }
    }

    return ribbons;
  }

  resolveRibbonsItemsIfCache(ribbons) {
    let maxRibbonsItems = settings.use_max_ribbons_items;
    if(isNaN(maxRibbonsItems)) {
      maxRibbonsItems = 0;
    }

    if(maxRibbonsItems > 0) {
      let i;
      let ribbons_copy = ribbons.components;
      if(Utils.isArray(ribbons_copy)) {
        for(i = 0; i < ribbons_copy.length; i++) {
          if(Utils.isArray(ribbons_copy[i].items) && ribbons_copy[i].items.length > maxRibbonsItems) {
            ribbons.components[i].items = ribbons_copy[i].items.slice(0, maxRibbonsItems);
          }
        }
      }
    }

    return ribbons;
  }

  async getAkmPBIImems(containPlanSelector, response, node, user_status){
        if (containPlanSelector && containPlanSelector.position) {
            try {
                const taskAkmPbi = new AkmPbiTask(node, user_status);
                const responseAkmPbi = await RequestManager.addRequest(taskAkmPbi);

                const items =
                    responseAkmPbi.response && responseAkmPbi.response.listButtons
                        ? responseAkmPbi.response.listButtons.button
                        : [];
                const params = {};
                const components = itemTransformerPlanSelector.collection(items, params);

                if (items) {
                    response.response.components[containPlanSelector.position].items = components;
                }
                return response;
            } catch(e) {
                console.error('AKMPBI error',  e);
            }
        }else {
            return response;
        }
    }

    async getLivechannelV3Items(positionCarrusel, response){
      if (positionCarrusel && positionCarrusel.url) {
            try {
                const taskLiveChannel = new LivechannelTask(positionCarrusel.url);
                const responseLiveChannel = await RequestManager.addRequest(taskLiveChannel);
                const items =
                        responseLiveChannel.data && responseLiveChannel.data.channels
                            ? responseLiveChannel.data.channels
                            : [];

                const params = {};
                const components = itemTransformerLevelV3.collection(items, params);

                if (items) {
                    response.response.components[positionCarrusel.position].items = components;
                    response.response.components[positionCarrusel.position].title = 'Últimos canales vistos';
                    response.response.components[positionCarrusel.position].type = 'UserLiveChannel';
                }

                return response;
            } catch(e) {
                console.error('v3/livechannel',  e);
            }
       } else {
            return response;
       }
    }

    async getLivechannelV3ItemsUpdate(url = ""){

        try {
            const taskLiveChannel = new LivechannelTask(url);
            const responseLiveChannel = await RequestManager.addRequest(taskLiveChannel);
            const items =
                    responseLiveChannel.data && responseLiveChannel.data.channels
                        ? responseLiveChannel.data.channels
                        : [];

            const params = {};
            const components = itemTransformerLevelV3.collection(items, params);
            return components;
        } catch(e) {
            console.error('v3/livechannel',  e);
        }

    }

    async getBygenre(positionCarrusel, response){
        if (positionCarrusel && positionCarrusel.url) {
            try {
                const taskBygenre = new BygenreTask(positionCarrusel.url);
                const responseBygenreTask = await RequestManager.addRequest(taskBygenre);
                const items =
                    responseBygenreTask.data && responseBygenreTask.data.events
                        ? responseBygenreTask.data.events
                        : [];

                const params = {};
                const components = itemTransformerBygenre.collection(items, params);

                if (items) {
                    response.response.components[positionCarrusel.position].items = components;
                    response.response.components[positionCarrusel.position].title = 'Eventos deportivos';
                    response.response.components[positionCarrusel.position].type = 'CarrouselLiveEvents';
                }

                return response;
            } catch(e) {
                console.error('v3/bygenre',  e);
            }
        } else {
            return response;
        }
    }

    async getBygenreUpdate(url = ""){
        try {
            const taskBygenre = new BygenreTask(url);
            const responseBygenreTask = await RequestManager.addRequest(taskBygenre);
            const items =
                responseBygenreTask.data && responseBygenreTask.data.events
                    ? responseBygenreTask.data.events
                    : [];

            const params = {};
            const components = itemTransformerBygenre.collection(items, params, url);

            return components;
        } catch(e) {
            console.error('v3/bygenre',  e);
        }
    }

    async searchAPIinLevelUser(api, response){
        let positionCarrusel = {};
        response.response.components.map((items, i) => {
            if (items && items.url && items.url.includes(api)) {
                positionCarrusel = {
                    contain: true,
                    position: i,
                    url: items.url
                };
            }
        });
        return positionCarrusel;
    }

  async getUserMiddlewareRibbons(node, user_status, callback,user_token=null, callbackError = null) {
    let success = false;
    const lastTouch = await getLastTouch(false, true)
    let params = {node, user_status, first_page: true, lastTouch};

    try {
      const task = new LevelUserTask('level-user',params);
      let response = await  RequestManager.addRequest(task);

      if(user_status !== 'anonymous'){
        const positionCarrusel = await this.searchAPIinLevelUser('v3/livechannel', response);
        response = await this.getLivechannelV3Items(positionCarrusel, response)
      }

      success = true;
      if (typeof callback === 'function') {
          const rcallback = callback(response.response);
      }

    } catch (e) {
      sendLoadAppErrorToNewRelic(DATA_LOAD_FAILURE)
      if(typeof callbackError === 'function'){
        callbackError();
      }
      logger.error('[RibbondUtil] getMiddlewareRibbons err', e);
    } finally {
      if(!success){
        sendLoadAppErrorToNewRelic(DATA_LOAD_FAILURE)
        if(typeof callbackError === 'function'){
          callbackError();
        }
      }
    }
  }

  static parserItem(group) {

    return {
      group_id: group.id,
      cover: group.image_small,
      image_still: group.image_still || group.image_small,
      portrait: group.image_medium,
      title: group.title || '',
      year: group.year || null,
      rating: group.rating_code || null,
      description: group.description,
      provider: group.proveedor_name,
      type: group.live_enabled === '1' ? 'live' : 'vod',
      format_types: group.format_types ? group.format_types.split(',') : group.format_types,
      href: this.getHref(group),
      channel_url: null,
      adUrl: null,
      ads: group.type === 'app_behaviour' ? 'app_behaviour' : null,
      live_enabled: group.live_enabled,
    };
  }

  static getHref(model) {
    let href = null;

    switch (model.type) {
      case 'group':
        href = `/vcard/${model.id || model.group_id}`;
        break;
      case 'node':
        href = `/node/${model.section}`;
        break;
      case 'special':
        href = `/special/${model.special}`;
        break;
      case 'live':
        href = `/player/${model.group_id || model.id}`;
        break;
      default:
        href = '';
        break;
    }

    if(model && model.type === 'app_behaviour') {
      if(model.app_behaviour === "/migracion/landing") {
          href =  "/migracion/landing";
      } else {
          href = '#'
      }
    }

    return href;
  }
  async getRibbons(nodeId, user_status, forceCall) {

    if (!nodeId) {
      return Promise.reject(this.ribbonsFail('[No valid node id]'));
    }

    if (forceCall === true) {
      ribbonsCache.clear();
      logger.debug('level api force ajax call');
    }

    let nodeRibbons;
    // Existe en cache?
    nodeRibbons = ribbonsCache.get(nodeId);
    if (nodeRibbons) {
      logger.debug('[LEVELUTIL] desde caché node: ' + nodeId);
      return Promise.resolve(nodeRibbons);
    }
    logger.debug('[LEVELUTIL] ajax call node: '  + nodeId);

    const resp = await this.getRibbonsFromApi(nodeId, user_status);
    if(resp) {
      if(resp.error === false) {
        nodeRibbons = this.parseLevelResponses(resp.data);
        // Add to cache, set TTL
        ribbonsCache.set(nodeId, nodeRibbons, settings.duration_of_ribbons_in_cache);
        return Promise.resolve(nodeRibbons);
      }
      else {
        return Promise.reject(resp.dataerror);
      }
    }
    else {
      return Promise.reject(this.ribbonsFail('[No response from method - API]'));
    }
  }

  async getRibbonsFromApi(nodeId, user_status) {

    let response = {
      data: null,
      error: false,
      dataerror: {}
    };

    const levelTask = new LevelTask(nodeId, user_status);
    const levelUserTask = new LevelUserTask(nodeId, user_status);

    let fl = FilterList.getFilter();
    const lastTouch = await getLastTouch("seen")
    const userSeenTask = new UserSeenTask(fl ? fl.filterlist : '', lastTouch);

    let levelTaskResponse = null;
    let leveluserTaskResponse = null;
    let userSeenTaskResponse = null;

    // IMPORTANTE: sólo en level se regresa error en caso de lo haya,
    // en leveluser y seenuser si hay error, no "se considera" entonces sólo se muestra
    // level
    const level_request = await RequestManager.addRequest(levelTask).then((resp1) => {
      // Is there an error?
      if (resp1.status == "1" || (resp1.response.modules && resp1.response.modules.length == 0)) {
        levelTaskResponse = null;
        response.dataerror = this.ribbonsFail('[Error level request API]');
        response.error = true;
      }
      else {
        levelTaskResponse = resp1;
      }
    }).catch((err) => {
      response.dataerror = this.ribbonsFail('[Error level request API ' + err + ']');
      response.error = true;
    });

    const leveluser_request = await RequestManager.addRequest(levelUserTask).then((resp2) => {
      leveluserTaskResponse = resp2;
    }).catch((err) => {
      // NO se envía error, esperando que sólo level api tenga info
      response.dataerror = this.ribbonsFail('[Error leveluser request API ' + err + ']');
    });

    const userseen_request = await RequestManager.addRequest(userSeenTask).then((resp3) => {
      userSeenTaskResponse = resp3;
    }).catch((err) => {
      // NO se envía error, esperando que sólo level api tenga info
      response.dataerror = this.ribbonsFail('[Error userseen request API ' + err + ']');
    });

    const levelresponses = [];
    levelresponses[0] = levelTaskResponse;
    levelresponses[1] = leveluserTaskResponse;
    levelresponses[2] = userSeenTaskResponse;
    response.data = levelresponses;


    return response;
  }


  async getMusicRibbonsFromApi(service, user, data) {
    let response = {
        data: null,
        error: false,
        dataerror: {}
    };

    const { cm_access_token, hasSubscription } = user;
    const ribbonsTask = new RibbonsTask(service, user, data, { cm_access_token });

    await RequestManager.addRequest(ribbonsTask)
        .then(res => {
            const transformResponse = this.transformResponse(
                res.response.components,
                hasSubscription
            );
            response = this.transformMusicRibbons(transformResponse);
        })
        .catch(err => {
            response.dataerror = this.ribbonsFail(`[Error music request API ${err}]`);
        });
    return response;
}

  transformResponse(resp, hasSubscription) {
      const final = {};
      if (resp && Array.isArray(resp)) {
          resp.forEach(el => {
              if (el && el.id) {
                  final[el.id] = {};
                  if (
                      el.properties &&
                      el.properties.title &&
                      el.properties.title.text &&
                      typeof el.properties.title.text === 'string' &&
                      el.properties.title.text !== ''
                  ) {
                      final[el.id].title = el.properties.title.text;
                  }
                  final[el.id].elements = this.getElementsToMap(el.items, el.id) || [];
              }
          });
      }
      return {
          ribbons: final,
          type: hasSubscription ? 2 : 1
      };
  }

  getElementsToMap(elements, kind) {
      let result = [];
      if (!elements || !Array.isArray(elements)) {
          return result;
      }

      result = elements.map((el, idx) => {
          let obj = {};
          let names = [];
          let ids = [];

          switch (kind) {
              case 'banners':
                  obj = {
                      id: el.entity_id || null,
                      title: el.title || '',
                      kind: this.getNewType(el.entity),
                      image: el.img || null,
                      record: el.record || null,
                      year: el.year || '',
                      followers: '',
                      tracks: el.num_tracks || '',
                      artists: el.author || '',
                      duration: el.duration || ''
                  };
                  break;
              case 'highlightedPlaylists':
                  obj = {
                      id: el.entity_id || null,
                      title: el.title || '',
                      image: el.img || null,
                      author: el.author || null,
                      isFollowing: false,
                      type: 'system',
                      phonograms: [],
                      followers: el.followers || null,
                      tracks: el.num_tracks || null,
                      duration: el.duration || null
                  };
                  break;
              case 'singlesReleases':
                  obj = {
                      id: el.entity_id || null,
                      title: el.title || '',
                      url: el.service_url || null,
                      artists: el.author[0] ? [el.author[0]] : [{}],
                      image: el.img || null,
                      isFavorited: false,
                      record: el.record || null,
                      year: el.year || null,
                      duration: el.duration || null,
                      artistsNames:
                          el.author && el.author[0] && el.author[0].name
                              ? [el.author[0].name]
                              : []
                  };
                  break;
              case 'albumsReleases':
                  obj = {
                      id: el.entity_id || null,
                      title: el.title || '',
                      url: el.service_url || null,
                      artists: el.author[0] ? [el.author[0]] : [{}],
                      image: el.img || null,
                      isFavorited: false,
                      numTracks: el.num_tracks || null,
                      record: el.record || null,
                      year: el.year || null,
                      duration: el.duration || null,
                      artistsNames:
                          el.author && el.author[0] && el.author[0].name
                              ? [el.author[0].name]
                              : []
                  };
                  break;
              case 'topSongs':
                  if (el.author && Array.isArray(el.author)) {
                      el.author.forEach(item => {
                          if (item.name) {
                              names.push(item.name);
                          }
                          if (item.id) {
                              ids.push(item.id);
                          }
                      });
                  }
                  obj = {
                      trackNumber: el.trackNumber || null,
                      albumId: el.albumId || null,
                      id: el.entity_id || null,
                      image: el.img || null,
                      name: el.title || '',
                      artist: names,
                      artists: el.author ? el.author : [],
                      artistId: ids,
                      duration: el.duration || null,
                      durationInSeconds: 0,
                      url: el.service_url || null,
                      isFavorited: typeof el.isFavorite === 'boolean' ? el.isFavorite : '',
                      albumName: el.albumName || null,
                      tracking: el.tracking || {}
                  };
                  break;
              case 'recommendations':
                  if (el.author && Array.isArray(el.author)) {
                      el.author.forEach(item => {
                          if (item.name) {
                              names.push(item.name);
                          }
                      });
                  }
                  obj = {
                      id: el.entity_id || null,
                      title: el.title || '',
                      url: el.service_url || null,
                      artists: el.author ? el.author : [],
                      image: el.img || null,
                      isFavorited: false,
                      record: el.record || null,
                      year: el.year || null,
                      duration: el.duration || null,
                      artistsNames: names
                  };
                  break;
              case 'topAlbums':
                  if (el.author && Array.isArray(el.author)) {
                      el.author.forEach(item => {
                          if (item.name) {
                              names.push(item.name);
                          }
                      });
                  }
                  obj = {
                      id: el.entity_id || null,
                      title: el.title || '',
                      url: el.service_url || null,
                      artists: el.author ? el.author : [],
                      image: el.img || null,
                      isFavorited: false,
                      numTracks: el.num_tracks || 0,
                      record: el.record || null,
                      year: el.year || null,
                      duration: el.duration || null,
                      artistsNames: names
                  };
                  break;
              case 'moodAndMoments':
                  obj = {
                      id: el.entity_id || null,
                      title: el.title || '',
                      image: el.img || null,
                      artists: el.author ? el.author : null,
                      isExternal: false,
                      type: 'system',
                      isUserPlaylist: false,
                      isOwnPlaylist: false,
                      isFollowing: false,
                      followers: el.followers || null,
                      tracks: el.num_tracks || null,
                      duration: el.duration || null
                  };
                  break;
              case 'highlights':
                  obj = {
                      id: el.entity_id || null,
                      title: el.title || '',
                      image: el.img || null,
                      artists: el.author ? el.author : null,
                      entidade: this.getNewType(el.entity),
                      followers: 0,
                      duration: el.duration || null
                  };
                  break;
              case 'topsRadios':
                  obj = {
                      id: el.entity_id || null,
                      image: el.img || null,
                      title: el.title || '',
                      url: el.service_url || null,
                      name: el.title || '',
                      dial: el.dial || null,
                      encoding: el.encoding || '',
                      isFavorite: typeof el.isFavorite === 'boolean' ? el.isFavorite : '',
                      band: el.band || null
                  };
                  break;
              case 'freePlaylists':
                  obj = {
                      id: el.entity_id || null,
                      title: el.title || '',
                      image: el.img || null,
                      author: el.author || null,
                      isFollowing: false,
                      type: 'free',
                      followers: el.followers || null,
                      tracks: el.num_tracks || null,
                      duration: el.duration || null
                  };
                  break;
              case 'artistsRadios':
                  obj = {
                      id: el.entity_id || null,
                      artist: el.title || '',
                      image: el.img || null,
                      artistRadio: true
                  };
                  break;
              case 'genresRadios':
                  obj = {
                      id: el.entity_id || null,
                      name: el.title || '',
                      genre: '',
                      image: el.img || null
                  };
                  break;
              case 'newsRadios':
                  obj = {
                      id: el.entity_id || null,
                      image: el.img || null,
                      title: el.title || '',
                      url: el.service_url || null,
                      name: el.title || '',
                      dial: el.dial || null,
                      band: el.band || null,
                      encoding: el.encoding || null,
                      isFavorite: false,
                      subType: 'talkStations'
                  };
                  break;
              default:
                  break;
          }
          return obj;
      });
      return result;
  }

  async getMusicListFromApi(service, user, data) {
    let response = {
        data: null,
        error: false,
        dataerror: {}
    };

    // Implementacion de nueva api
    // /middleware/cms/playlistDetail
    // Toggle deberia ir aqui
    if (service && service.includes('playlistSTV/')) {
        response = await AlbumDetailAdapter.getData({
            service: service,
            user: user,
            data: data
        });
        return response;
    }

    const musicTask = new MusicTask(service, user, data, {
        cm_access_token: user.cm_access_token
    });
    await RequestManager.addRequest(musicTask)
        .then(res => {
            response = res;
        })
        .catch(err => {
            response.dataerror = this.ribbonsFail(`[Error music request API ${err}]`);
        });
    return response;
  }

  async getMusicRadioFromApi(service, user, data) {
    let response = {
      data: null,
      error: false,
      dataerror: {}
    };

    const musicTask = new FollowRadioTask(service, user, data, {
      cm_access_token: user.cm_access_token
    });
    await RequestManager.addRequest(musicTask)
      .then(res => {
        response = res;
      })
      .catch(err => {
        response.dataerror = this.ribbonsFail(`[Error music request API ${err}]`);
      });
    return response;
  }

  async getListFromApi(service, user, data) {
      const { musicUser } = user;
      let response = {
          data: null,
          error: false,
          dataerror: {}
      };

      data.cm_access_token = musicUser.cm_access_token;
      const musicTask = new PlaylistTask(service, user, data, null);
      await RequestManager.addRequest(musicTask)
          .then(res => {
              response = res;
          })
          .catch(err => {
              response.dataerror = this.ribbonsFail(`[Error music request API ${err}]`);
          });
      return response;
  }

  async getMenuApi(service, user, data) {
      const { musicUser } = user;
      let response = {
          data: null,
          error: false,
          dataerror: {}
      };

      data.cm_access_token = musicUser.cm_access_token;
      const musicTask = new FilterTask(service, user, data, null);
      await RequestManager.addRequest(musicTask)
          .then(res => {
              response = res;
          })
          .catch(err => {
              response.dataerror = this.ribbonsFail(`[Error filter request API ${err}]`);
          });
      return response;
  }


  async getRadiosApi(service, user, data) {
      let response = {
          data: null,
          error: false,
          dataerror: {}
      };

      const radiosTask = new RadiosTask(service, user, data, {
          cm_access_token: user.cm_access_token
      });
      await RequestManager.addRequest(radiosTask)
          .then(res => {
              response = res;
          })
          .catch(err => {
              response.dataerror = this.ribbonsFail(`[Error filter request API ${err}]`);
          });
      return response;
  }

  transformMusicRibbons(musicCarousels) {
    let ribbons = {};
    const musicRibbons = musicCarousels.ribbons;
    const type = Number(musicCarousels.type);
    let playlistFreeId;
    try {
      playlistFreeId = musicRibbons.freePlaylists.elements[0] !== undefined ?
          musicRibbons.freePlaylists.elements[0].id : "0000000";
    } catch (e) {
      playlistFreeId = "0000000";
    }

    if(type === 2) {
      delete musicRibbons['freePlaylists'];
      delete musicRibbons['newsRadios'];
      delete musicRibbons['genresRadios'];
      delete musicRibbons['artistsRadios']
    }

    if(type === 1){
      delete musicRibbons['highlightedPlaylists'];
      delete musicRibbons['singlesReleases'];
      delete musicRibbons['albumsReleases'];
      delete musicRibbons['songsReleases'];
      delete musicRibbons['topSongs'];
      delete musicRibbons['recommendations'];
      delete musicRibbons['topAlbums'];
      delete musicRibbons['moodAndMoments'];
      delete musicRibbons['highlights'];
    }

    delete musicRibbons['isFirstTime'];
    delete musicRibbons['djs'];
    delete musicRibbons['events'];

    ribbons = Object.keys(musicRibbons).filter((el) => musicRibbons[el].elements.length > 0 ).map((rkey, index) => {

      const musicRibbon = musicRibbons[rkey];
      const ribbon = {
        components: {},
        name: rkey,
        ribbonindex: index,
        ribbontitles: {
          extrasmall: musicRibbon.title,
          small: musicRibbon.title,
          large: musicRibbon.title,
          medium: musicRibbon.title,
        },
        type: 'carousel',
        type2: rkey === 'banners' ? 'Highlight' : rkey === 'artistsRadios' ? 'circle' : 'landscape',
        url: 'musicLocal',
        elements: this.transformMusicRibbonsElements(musicRibbon.elements, rkey, index)
      }
      return ribbon;
    });
    return {ribbons, playlistFreeId, topSongs: musicRibbons['topSongs'] || []};
  }

  transformMusicRibbonsElements(elements, kind, index){
      let ribbonElements = [];

      switch (kind){
        case 'banners':
          ribbonElements = elements.filter(c => c.kind !== 'link')
            .filter(c => c.kind !== 'radioStation')
            .filter(c => c.kind !== 'radioGenre')
            .filter(c => c.kind !== 'radio')
            .map((card) => {
             return {
               crest: null,
               title: card.title ? Utils.htmlDecode(card.title) : '',
               cover: card.image,
               image_background: card.image,
               image_highlight: card.image,
               image_large: card.image,
               image_medium: card.image,
               image_small: card.image,
               url: `${card.kind}/${card.id}`,
               group_id: kind,
               index: index,
               description: card.title ? `${card.title}` : '',
               rating_code: '',
               music_class: kind,
               href: `/${card.kind}/${card.id}`,
               type: card.kind.replace(/\b\w/g, l => l.toUpperCase()),
               musicData: card,
               artist: card.artists ? card.artists : '',
               tracks: card.tracks ? `${card.tracks} canciones` : '',
               duration: card.duration ? card.duration : '',
               followers: card.followers ? `${card.followers} seguidores` : '',
               record: card.record ? card.record : '',
               year: card.year ? card.year : '',
             }
          });
          break;
        case 'topSongs':
          ribbonElements = elements.map((card) => {
            return {
              crest: card.artist ? card.artist.join(' ,') : '',
              title: card.name ? card.name : '',
              cover: card.image,
              image_background: card.image,
              image_highlight: card.image,
              image_large: card.image,
              image_medium: card.image,
              image_small: card.image,
              url: '',
              group_id: kind,
              index: index,
              description: card.title ? `${card.title}` : '',
              rating_code: '',
              music_class: kind,
              href: `#`,
              type: 'Song',
              musicData: card,
            }
          });
          break;
        case 'artistsRadios':
          ribbonElements = elements.map((card) => {
            return {
              crest: null,
              title: card.artist ? card.artist : '',
              cover: card.image,
              image_background: card.image,
              image_highlight: card.image,
              image_large: card.image,
              image_medium: card.image,
              image_small: card.image,
              url: `${card.kind}/${card.id}`,
              group_id: kind,
              index: index,
              description: card.title ? `${card.title}` : '',
              rating_code: '',
              music_class: kind,
              href: `/radioList/artist/${card.id}`,
              type: 'radios',
              artist: true,
              musicData: card,
            }
          });
          break;
        case 'genresRadios':
          ribbonElements = elements.map((card) => {
            return {
              crest: '',
              title: card.name ? card.name : '',
              cover: card.image,
              image_background: card.image,
              image_highlight: card.image,
              image_large: card.image,
              image_medium: card.image,
              image_small: card.image,
              url: `${card.kind}/${card.id}`,
              group_id: kind,
              index: index,
              description: card.title ? `${card.title}` : '',
              rating_code: '',
              music_class: kind,
              href: `/radioList/genre/${card.name}`,
              type: 'radios',
              genre: true,
              musicData: card,
            }
          });
          break;
        case 'newsRadios':
        case 'topsRadios':
          ribbonElements = elements.filter(e => e.encoding === 'MP3').map((card) => {
            return {
              crest: '',
              title: card.name ? card.name : '',
              cover: card.image,
              image_background: card.image,
              image_highlight: card.image,
              image_large: card.image,
              image_medium: card.image,
              image_small: card.image,
              url: `${card.kind}/${card.id}`,
              group_id: kind,
              index: index,
              description: card.title ? `${card.title}` : '',
              rating_code: '',
              music_class: kind,
              href: `#`,
              type: 'Radio',
              musicData: card,
              dial: card.dial ? card.dial : '',
              band: card.band ? card.band : '',
            }
          });
          break;
        case 'highlights':
        case 'superhighlight_title':
            ribbonElements = elements.map((card) => {
              return {
                crest: '',
                title: card.title ? card.title : '',
                cover: card.image,
                image_background: card.image,
                image_highlight: card.image,
                image_large: card.image,
                image_medium: card.image,
                image_small: card.image,
                url: `${card.kind}/${card.id}`,
                group_id: kind,
                index: index,
                description: card.title ? `${card.title}` : '',
                rating_code: '',
                music_class: kind,
                href: `/${this.getMusicUrl(card.entidade)}/${card.id}`,
                type: card.entidade.replace(/\b\w/g, l => l.toUpperCase()),
                musicData: card,
                artist: card.artistsNames ? card.artistsNames : '',
                tracks: card.tracks ? `${card.tracks} canciones` : '',
                duration: card.duration ? card.duration : '',
                followers: card.followers ? `${card.followers} seguidores` : '',
                record: card.record ? card.record : '',
                year: card.year ? card.year : '',
              }
            });
            break;
        default:
          ribbonElements = elements.map((card) => {
            return {
              crest: '',
              title: card.title ? card.title : '',
              name: card.name ? card.name : '',
              cover: card.image,
              image_background: card.image,
              image_highlight: card.image,
              image_large: card.image,
              image_medium: card.image,
              image_small: card.image,
              url: `${card.kind}/${card.id}`,
              group_id: kind,
              index: index,
              description: card.title ? `${card.title}` : '',
              rating_code: '',
              music_class: kind,
              href: `/${this.getMusicUrl(kind)}/${card.id}`,
              type: this.getMusicUrl(kind).replace(/\b\w/g, l => l.toUpperCase()),
              musicData: card,
              artist: card.artistsNames ? card.artistsNames : '',
              tracks: card.tracks ? `${card.tracks} canciones` : '',
              duration: card.duration ? card.duration : '',
              followers: card.followers ? `${card.followers} seguidores` : '',
              record: card.record ? card.record : '',
              year: card.year ? card.year : '',
            }
          });
          break;
      }

    return ribbonElements;
  }


  async getIsFavoriteFromApi(contentType, user, data) {
    let response = {
        data: null,
        error: false,
        dataerror: {}
    };

    const isFavoriteTask = new IsFavoriteTask(contentType, user, data);
    await RequestManager.addRequest(isFavoriteTask)
        .then(res => {
            response = res;
        })
        .catch(err => {
            response.error = err;
        });
    return response;
  }


  async getMyMusicFromApi(service, user, data) {
    let response = {
        data: null,
        error: false,
        dataerror: {}
    };

    service = service.includes('favoriteAlbumsByUser') ? 'favoriteAlbums' : service;

    const myMusicDetailTask = new MyMusicDetailTask(service, user, data);
    await RequestManager.addRequest(myMusicDetailTask)
        .then(res => {
            response = res;
        })
        .catch(err => {
            response.dataerror = this.ribbonsFail(`[Error music request API ${err}]`);
        });
    return response;
  }


  getNewType(type) {
    let result = type;
    switch (type) {
          case ENTITIES_TYPES.RADIO:
            result = 'radio';
            break;
          case ENTITIES_TYPES.SYSTEM_PLAYLIST:
              result = 'playlist';
              break;
          case ENTITIES_TYPES.ALBUM:
              result = 'album';
              break;
          case ENTITIES_TYPES.PLAYLIST:
              result = 'playlist';
              break;
          default:
            result = 'playlist';
      }
      return result;
  }

  async getMusicSetupPlay(cm_access_token) {
    let response = {
          success: false,
          result: null,
          error: {}
      };
      const setupPlayTask = new SetupPlayTask(cm_access_token);
      await RequestManager.addRequest(setupPlayTask)
          .then(res => {
              const { success = false, response: { result = '' } = {}, msg = {} } = res;
              if (success === true) {
                  response.success = true;
                  response.result = result;
              } else {
                  response.error = msg;
              }
          })
          .catch(err => {
              response.error = err;
          });

      return response;
  }

  async getMusicCheckSinglePlay(cm_access_token) {
    let response = {
        success: false,
        result: null,
        error: {}
    };
      const checkSinglePlayTask = new CheckSinglePlayTask(cm_access_token);
      await RequestManager.addRequest(checkSinglePlayTask)
          .then(res => {
              const { success = false, response: { result = '' } = {}, msg = {} } = res;
              if (success === true) {
                  response.success = true;
                  response.result = result;
              } else {
                  response.error = msg;
              }
          })
          .catch(err => {
              /**
                 ¿Está reproduciendo en otro device simultaneo?
                  When simultaneo:
                  err = {
                      message: {code: "CMS_049", description: "Maybe playing in another device"},
                      completeError: {entry: {…}, status: 500, success: false, msg: {…}},
                      code: null
                  }
              */
              if (err && err.message && err.message.code && err.message.code === 'CMS_049') {
                  response.error = err.message;
                  response.result = err;
              } else {
                  response.error = err;
              }
          });

      return response;
  }

  getMusicUrl(kind) {
    switch (kind) {
      case 'albumsReleases':
      case 'topAlbums':
      case 'highlights':
      case 'recommendations':
      case 'singlesReleases':
      case 'album':
        return 'album';
      case 'newsRadios':
      case 'topRadios':
      case 'genresRadios':
        return 'radios';
      default:
        return 'playlist';
    }
  }

  ribbonsFail(err) {
    let error = { msg: 'error_generic_playout',  type: 'error_generic_playout', strerr: err };

    return error;
  }

  async parseLevelResponses(responses) {

    let levelRes = responses[0];
    let leveluserRes = responses[1];
    let seenRes = responses[2];

    /*
    //Sólo para testing y hardcodeo
    levelRes = this.testLevelAPI();
    leveluserRes = this.testLeveluserAPI();
    seenRes = this.testSeenuserAPI();
    */

    let i, j, k;

    // leveluserRes y seenRes pueden ser nulos, al menos levelRes debería traer respuesta
    if(levelRes) {
      if(leveluserRes && seenRes && leveluserRes.response) {
        for (i = 0; i < leveluserRes.response.modules.module.length; i++) {
          for (j = 0; j < levelRes.response.modules.module.length; j++) {
            if (levelRes.response.modules.module[j].name == leveluserRes.response.modules.module[i].name)
            {
              for (k = 0; k < levelRes.response.modules.module[j].components.component.length; k++)
              {
                if (levelRes.response.modules.module[j].type == "carrouselrecommended1" && levelRes.response.modules.module[j].components.component[k].name == "carrousel")
                {
                  levelRes.response.modules.module[j].components.component[k].properties =
                    leveluserRes.response.modules.module[i].components.component[0].properties;
                  if (seenRes.msg != "ERROR")
                  {
                    if (seenRes.response.groups.length > 0 && seenRes.response.groups.length >= levelRes.response.modules.module[j].components.component[k].properties.offset)
                    {
                      let offset = levelRes.response.modules.module[j].components.component[k].properties.offset;
                      //Validación en caso que el offset no esté dentro del rango de la colección de seen
                      if (offset && offset < seenRes.response.groups.length)
                      {
                        let vGroup_id = seenRes.response.groups[offset].id;
                        levelRes.response.modules.module[j].components.component[k].properties.url += "&group_id=" + vGroup_id;
                        levelRes.response.modules.module[j].components.component[k].properties.seen = seenRes.response.groups[levelRes.response.modules.module[j].components.component[k].properties.offset];
                      }
                      else
                      {
                        logger.info('** El offset es mayor que la colección en seen y no se pinta el ribbon recomendados');
                      }
                    }
                  }
                }
                else if (levelRes.response.modules.module[j].components.component[k].name == "carrousel") {
                  levelRes.response.modules.module[j].components.component[k].properties =
                    leveluserRes.response.modules.module[i].components.component[0].properties;
                }
                else if (levelRes.response.modules.module[j].components.component[k].name == "carrouselizq") {
                  levelRes.response.modules.module[j].components.component[k].properties =
                    leveluserRes.response.modules.module[i].components.component[0].properties;
                }
                else if (levelRes.response.modules.module[j].components.component[k].name == "carrouselder") {
                  levelRes.response.modules.module[j].components.component[k].properties =
                    leveluserRes.response.modules.module[i].components.component[1].properties;
                }
              }
            }
          }
        }
      }
    }

    // Después de ajustar con leveluser y seenuser
    return this.__getRibbonUrls(levelRes.response.modules.module);
  }

  __getRibbonUrls(ribbons) {
    var ret = [];

    let i, j;
    let ct = 1;
    for(i = 0; i < ribbons.length; i++) {
      let unribbon = ribbons[i];

      let car_url = this.__setUrl(unribbon);
      if(car_url) {
        for(j = 0; j < car_url.length; j++) {
          ret.push(car_url[j]);
        }
      }
    }

    return ret;
  }

  __setUrl(data) {
    let ret = [];

    if (typeof (data) === 'undefined') {
      return null;
    }

    let component = data.components.component;

    let url = this.__getMfwUrl(component);
    let url2 = null;

    data.type2 = this.__getMfwType(component);
    if (!url) {
      url = this.__getMfwUrlName(component, 'carrouselizq');
      data.type2 = this.__getMfwTypeName(component, 'carrouselizq');
      url2 = this.__getMfwUrlName(component, 'carrouselder');
    }

    if (!url) {
      return null;
    }

    data.url = url;
    data.ribbontitles = this.__getMfwRibbonTitle(component);
    ret.push(data);
    if (url2) {
      let data2 = {}
      data2.components = data.components;
      data2.name = data.name;
      data2.type = "carrouseldoble";
      data2.type2 = this.__getMfwTypeName(component, 'carrouselder');
      data2.url = url2;
      data2.ribbontitles = this.__getMfwRibbonTitle(data2.components.component);

      ret.push(data2);
    }

    return ret;
  }

  __getMfwUrl(component) {
    let nameT = "carrousel";
    let i;
    for (i = 0; i < component.length; i++) {
      if (nameT == component[i].name) {
        let properties = component[i].properties;
        return properties.url;
      }
    }
  }

  __getMfwUrlName(component, name) {
    let nameT = name;
    let i;
    for (i = 0; i < component.length; i++) {
      if (nameT == component[i].name) {
        let properties = component[i].properties;
        return properties.url;
      }
    }
  }

  __getMfwType(component) {
    let nameT = "carrousel";
    let i;
    for (i = 0; i < component.length; i++) {
      if (nameT == component[i].name) {
        return component[i].type;
      }
    }
  }

  __getMfwTypeName(component, name) {
    let nameT = name;
    let i;
    for (i = 0; i < component.length; i++) {
      if (nameT == component[i].name) {
        return component[i].type;
      }
    }
  }

  __getMfwRibbonTitle(component) {
    let titles = {};
    titles.extrasmall = '';
    titles.large = '';
    titles.medium = '';
    titles.small = '';

    let nameT = "header";
    let i;
    for (i = 0; i < component.length; i++) {
      if (nameT == component[i].name) {
        let properties = component[i].properties;
        titles.extrasmall = properties.extrasmall ? properties.extrasmall : '';
        titles.large = properties.large ? properties.large : '';
        titles.medium = properties.medium ? properties.medium : '';
        titles.small = properties.small ? properties.small : '';
      }
    }

    return titles;
  }

  static getThirdLevelMenu(code, nodes){
    const result = {
      node : null,
      parent : null
    }
    const selectedNode = this.getNodeByCode(code, nodes);
    const {level = 0, id_parent = null} = selectedNode || {};

    result.node = selectedNode;

    if (level > 1 ){
      if (!Array.isArray(selectedNode.childs)){
        result.parent = this.getNodeById(id_parent, nodes);
      }
    }
    return result
  }

  static getNodeByCode(code, nodes){
    if(Array.isArray(nodes) && nodes.length > 0){
      const nodeFounded = nodes.find((node)=>node.code === code);
      if (nodeFounded) return nodeFounded;
      else {
        let subnode = false;
        nodes.filter((node)=>node.childs && Array.isArray(node.childs))
        .forEach((node)=>{
          if (subnode) {
            return;
          }
          subnode = this.getNodeByCode(code, node.childs);
        });
        return subnode;
      }
    }
    return {};
  }

  static getNodeById(id, nodes){
    if(Array.isArray(nodes) && nodes.length > 0){
      const nodeFounded = nodes.find((node)=>node.id === id);
      if (nodeFounded) return nodeFounded;
      else {
        let subnode = false;
        nodes.filter((node)=>node.childs && Array.isArray(node.childs))
        .forEach((node)=>{
          if (subnode) return;
          subnode = this.getNodeById(id, node.childs);
        });
        return subnode;
      }
    }
    return {};
  }

  static getRibbonsCategories( nextCode, nodes){
    if(!(Array.isArray(nodes) && nodes.length > 0))
      return null;
    let response = null;
    //Se inyecta tercer nivel
    const {node, parent } = this.getThirdLevelMenu(nextCode, nodes) || {};
    const currentNode = node;
    const parentNode = parent;
    let objAppBehaviour = '';
    let isVisibleNode = false;

    if (Object.keys(currentNode).length !== 0) {
      objAppBehaviour = JSON.parse(currentNode.app_behaviour);
    }

    if (objAppBehaviour !== null) {
      if ((objAppBehaviour.layout === undefined || objAppBehaviour.layout === 'filterbygenre') && currentNode.level === 2) {
        isVisibleNode = true;
      }
    }

    const currentNodeLevel = isVisibleNode || currentNode.level === 3 || currentNode.level === 4;

    if (currentNode && (currentNodeLevel || (currentNode.childs && Array.isArray(currentNode.childs)))) {
      let children = currentNode.childs;
      if(parentNode){
        children = parentNode.childs;
      }
      if(children){
        const items = children.map((child)=>{
          return{
            href: `/node/${child.code}`,
            title: child.text,
            type: "submenu",
            selected: child.code === nextCode
          }
        });
        response = {
          id: "Submenu",
          items,
          type: "category",
        }
      }
    }
    return response;
  }

  dataUpdateMetrics({node_item, node_location, ribbon_title}){
    const {navbar:{from:{node_initial}}} = store.getState()
    store.dispatch(setFromData({
      node_initial:node_initial || "inicio",
      node_location : node_location,
      ribbon_title : ribbon_title || "",
      card_element: {
          title: node_item.title,
          provider: node_item.provider
        }
    }));
  }

}

export default RibbonsUtil



// WEBPACK FOOTER //
// ./src/utils/RibbonsUtil.js